import styled from 'styled-components';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { mainColor } from '../../../lib/theme';
import { FAB_Z_INDEX, PANEL_HEIGHT, PANEL_WIDTH, PANEL_Z_INDEX } from './chatbot.constants';

// Fixed bottom-right launcher, above the report-card print button (zIndex 1000).
// Hidden in print so the printed report card carries no stray icon.
export const LauncherFab = withStyles(() => ({
  root: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: FAB_Z_INDEX,
    background: mainColor,
    color: '#fff',
    '&:hover': { background: mainColor, opacity: 0.92 },
    '@media print': { display: 'none' },
  },
}))(Fab);

export const PanelContainer = styled(Paper)`
  && {
    position: fixed;
    bottom: 96px;
    right: 24px;
    width: ${PANEL_WIDTH}px;
    max-width: calc(100vw - 32px);
    height: ${PANEL_HEIGHT}px;
    max-height: calc(100vh - 128px);
    z-index: ${PANEL_Z_INDEX};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    @media print { display: none; }
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  background: #fafcfe;
  flex-shrink: 0;
`;

export const PanelTitle = styled.div`
  font-weight: 600;
  font-size: 15px;
`;

export const MessagesScroll = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 12px 16px;
  background: #fff;
`;

export const MessageRow = styled.div<{ role: 'user' | 'assistant' | 'system' }>`
  display: flex;
  justify-content: ${(p) => (p.role === 'user' ? 'flex-end' : 'flex-start')};
  margin-bottom: 8px;
`;

export const MessageBubble = styled.div<{ role: 'user' | 'assistant' | 'system' }>`
  max-width: 80%;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  background: ${(p) => (p.role === 'user' ? mainColor : '#f1f3f5')};
  color: #1a1a1a;

  & p { margin: 0 0 0.5em 0; }
  & p:last-child { margin-bottom: 0; }
  & ul, & ol { margin: 0.25em 0 0.5em 1.25em; padding: 0; }
  & ul:last-child, & ol:last-child { margin-bottom: 0; }
  & li { margin-bottom: 0.15em; }
  & li:last-child { margin-bottom: 0; }
  & code {
    background: rgba(0, 0, 0, 0.08);
    padding: 1px 5px;
    border-radius: 3px;
    font-size: 0.92em;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  }
`;

export const ErrorBanner = styled.div`
  padding: 8px 16px;
  background: #fdecea;
  color: #5f2120;
  font-size: 13px;
  border-top: 1px solid #f5c2c0;
`;

export const StartersWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 12px 0 12px;
  background: #fff;
  flex-shrink: 0;
`;

// Deliberately the blue palette (not the app's green mainColor) so chips read as
// a third surface, distinct from the green user and gray bot bubbles.
export const StarterChip = styled.button`
  background: #fff;
  border: 1px solid #c8d8e8;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  color: #2c5282;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  &:hover:not(:disabled) { background: #e8f0fb; border-color: #a8c4e0; }
  &:disabled { cursor: not-allowed; opacity: 0.6; }
`;

export const InputBar = styled.form`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid #eee;
  background: #fff;
  flex-shrink: 0;
`;
